import { ICommandBase } from "@Alternatives/cqrs";

export class CreateNotificationCommandV1 implements ICommandBase
{
    $type: string = 'TCh.Domain.Alternatives.Notifications.Commands.CreateNotificationCommandV1, TCh.Domain.Alternatives';

    WorkspaceId: number;
    ProjectId: number;
    AlternativesListId: number;
    Id: string; 
    Name: string;
    Description: string;
    Enabled: boolean;
    AlternativeStatusId: number;
    PreviousAlternativeStatusId: number | null;
    Subject: string;
    Message: string;
    RecipientAttributeId: number | null;
    AdHocRecipients: string;
    ReplyToEmail: string;

    constructor(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number,
        name: string, description: string, enabled: boolean, alternativeStatusId: number, previousAlternativeStatusId: number | null,
        subject: string, message: string, recipientAttributeId: number | null, adHocRecipients: string, replyToEmail: string)
    {
        this.WorkspaceId = workspaceId;
        this.ProjectId = projectId;
        this.AlternativesListId = alternativesListId;
        this.Id = notificationId.toString();
        this.Name = name;
        this.Description = description;
        this.Enabled = enabled;
        this.AlternativeStatusId = alternativeStatusId;
        this.PreviousAlternativeStatusId = previousAlternativeStatusId;
        this.Subject = subject;
        this.Message = message;
        this.RecipientAttributeId = recipientAttributeId;
        this.AdHocRecipients = adHocRecipients;
        this.ReplyToEmail = replyToEmail;
    }

    static matchType(cmd: ICommandBase)
    {
        return cmd.$type === 'TCh.Domain.Alternatives.Notifications.Commands.CreateNotificationCommandV1, TCh.Domain.Alternatives';
    }
}

export class UpdateNotificationCommandV1 implements ICommandBase
{
    $type: string = 'TCh.Domain.Alternatives.Notifications.Commands.UpdateNotificationCommandV1, TCh.Domain.Alternatives';

    WorkspaceId: number;
    ProjectId: number;
    AlternativesListId: number;
    Id: string; 
    Name: string;
    Description: string;
    Enabled: boolean;
    AlternativeStatusId: number;
    PreviousAlternativeStatusId: number | null;
    Subject: string;
    Message: string;
    RecipientAttributeId: number | null;
    AdHocRecipients: string;
    ReplyToEmail: string;

    constructor(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number,
        name: string, description: string, enabled: boolean, alternativeStatusId: number, previousAlternativeStatusId: number | null,
        subject: string, message: string, recipientAttributeId: number | null, adHocRecipients: string, replyToEmail: string)
    {
        this.WorkspaceId = workspaceId;
        this.ProjectId = projectId;
        this.AlternativesListId = alternativesListId;
        this.Id = notificationId.toString();
        this.Name = name;
        this.Description = description;
        this.Enabled = enabled;
        this.AlternativeStatusId = alternativeStatusId;
        this.PreviousAlternativeStatusId = previousAlternativeStatusId;
        this.Subject = subject;
        this.Message = message;
        this.RecipientAttributeId = recipientAttributeId;
        this.AdHocRecipients = adHocRecipients;
        this.ReplyToEmail = replyToEmail;
    }

    static matchType(cmd: ICommandBase)
    {
        return cmd.$type === 'TCh.Domain.Alternatives.Notifications.Commands.UpdateNotificationCommandV1, TCh.Domain.Alternatives';
    }
}




export class DeleteNotificationCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Notifications.Commands.DeleteNotificationCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = notificationId.toString();
	}

    static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Notifications.Commands.DeleteNotificationCommandV1, TCh.Domain.Alternatives';
	}
}

